import { normalizeRideName } from '../domain/ride-name';
import type { Ride } from '../domain/ride';

const PREFIX = 'ride-trace:ride-name:';

/** Restores a name for this source track without making import depend on storage access. */
export function restoreRideName(ride: Ride): Ride {
  if (!ride.sourceFingerprint) return ride;
  try {
    const saved = localStorage.getItem(PREFIX + ride.sourceFingerprint);
    return saved === null ? ride : { ...ride, title: normalizeRideName(saved) };
  } catch {
    return ride;
  }
}

/** Returns whether the name can be remembered after this browser session. */
export function rememberRideName(ride: Ride, title: string): boolean {
  const name = normalizeRideName(title);
  if (!ride.sourceFingerprint) return false;
  try {
    localStorage.setItem(PREFIX + ride.sourceFingerprint, name);
    return true;
  } catch {
    return false;
  }
}
